/**
 * Feature flags for white-label configuration
 * Set to false to hide features from the UI while keeping the code intact
 */
export const FEATURE_FLAGS = {
  /** DVX token functionality: buy DVX button, fee reduction toggle, etc. */
  DVX_ENABLED: false,
  
  /** Exchange functionality: Exchange page, Exchange account in portfolio */
  EXCHANGE_ENABLED: false,
};
